/*
 * Created Date: 16-08-2022, 11:37:36 am
 * Author: Peter
 * Email: phantrung696@gmail.com
 * -----
 * Last Modified:
 * Modified By:
 * -----
 * Copyright (c) 2022 PT CORP, Inc
 * -----
 * HISTORY:
 * Date      	By	Comments
 * ----------	---	----------------------------------------------------------
 */
import { USER_INFO_TYPE } from '@Core/Components/const'
import { get } from 'lodash'
import { getAuthDataSession, getCurrentWorkspaceSession } from './Session'
export const getUserFullName = user => {
	// eslint-disable-next-line prefer-template
	const fullname = get(user, 'info.fullname')
	return fullname || `${get(user, 'info.last_name') ?? null} ${get(user, 'info.first_name') ?? null}`
}

export const hasPermission = (authArr, userRole) => {
	/**
	 * If auth array is not defined
	 * Pass and allow
	 */
	if (authArr === null || authArr === undefined) {
		// console.info("auth is null || undefined:", authArr);
		return true
	}

	if (Array.isArray(authArr) && authArr.includes('*')) {
		return true
	}

	if (authArr.length === 0) {
		/**
		 * if auth array is empty means,
		 * allow only user role is guest (null or empty[])
		 */
		// console.info("auth is empty[]:", authArr);
		return !userRole || userRole.length === 0
	}
	/**
	 * Check if user has grants
	 */
	// console.info("auth arr:", authArr);
	/*
            Check if user role is array,
            */
	if (userRole && Array.isArray(userRole)) {
		return authArr.some(r => userRole.indexOf(r) >= 0)
	}

	/*
            Check if user role is string,
            */
	return authArr.includes(userRole)
}

export const isUserStudent = () => {
	const type = getAuthDataSession('info.type')
	return type === USER_INFO_TYPE.student
}

export const isUserTeacher = () => {
	const type = getAuthDataSession('info.type')
	return type === USER_INFO_TYPE.teacher
}

export const isUserOrganization = () => {
	const type = getAuthDataSession('info.type')
	return type === USER_INFO_TYPE.org
}

export const isChannelPersonal = () => {
	const type = getCurrentWorkspaceSession('type')
	return type === 'PERSONAL'
}

export const isChannelBusiness = () => {
	const type = getCurrentWorkspaceSession('type')
	return type === 'BUSINESS'
}

export const isChannelTHPT = () => {
	const id = getCurrentWorkspaceSession('id')
	return id === 44975
}
